export default __webpack_public_path__ + "static/media/ilookdumb.dff21308.jpeg";